export default function usDateFormatLast7Days(dateTime) {
  // Always use current browser time if no dateTime provided
  let endDate = dateTime ? new Date(dateTime) : new Date();

  let startDate = new Date(endDate);
  startDate.setTime(endDate.getTime() - 1000 * 60 * 60 * 24 * 7);

  // const startLocaleDateString = startDate.toLocaleDateString("en-US", {
  //   timeZone: "America/New_York",
  //   year: "numeric",
  //   month: "2-digit",
  //   day: "2-digit",
  // });

  // const [startMonthNum, startDateNum, startYearNum] =
  //   startLocaleDateString.split("/");

  // const endLocaleDateString = endDate.toLocaleDateString("en-US", {
  //   timeZone: "America/New_York",
  //   year: "numeric",
  //   month: "2-digit",
  //   day: "2-digit",
  // });

  // const [endMonthNum, endDateNum, endYearNum] = endLocaleDateString.split("/");

  return {
    startDateTime: startDate.toISOString(),
    endDateTime: endDate.toISOString(),
  };
}

export function diffTime(dt1, dt2) {
  // Calculate the difference in milliseconds between the two provided Date objects by subtracting the milliseconds value of dt1 from the milliseconds value of dt2
  let diff = (dt2.getTime() - dt1.getTime()) / 1000;
  let unit = "seconds";

  if (diff > 60 * 60 * 24) {
    // Convert the difference from milliseconds to days by dividing it by the number of seconds in an hour (3600)
    diff /= 60 * 60 * 24;
    unit = "days";
  } else if (diff > 3600) {
    // Convert the difference from milliseconds to hours by dividing it by the number of seconds in an hour (3600)
    diff /= 60 * 60;
    unit = "hours";
  } else if (diff > 60) {
    // Convert the difference from milliseconds to minutes by dividing it by the number of seconds in an hour (3600)
    diff /= 60;
    unit = "minutes";
  }

  // Return the absolute value of the rounded difference in hours
  return {
    diff: Math.abs(Math.round(diff)),
    unit,
  };
}
